import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	confirmButtonLabel: {
		id: 'inline-edit.confirm-button-label',
		defaultMessage: 'Confirm {fieldName}',
		description:
			'An accessibility label for a confirm button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button saves the contents of the input field.',
	},
	cancelButtonLabel: {
		id: 'inline-edit.cancel-button-label',
		defaultMessage: 'Cancel {fieldName}',
		description:
			'An accessibility label for a cancel button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button reverts the contents of the input field to their previous value.',
	},
	editButtonLabel: {
		id: 'inline-edit.edit-button-label',
		defaultMessage: 'Edit {fieldName}',
		description:
			'An accessibility label for an edit button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button allows the user to edit the contents of the input field.',
	},
	addButtonLabel: {
		id: 'inline-edit.add-button-label',
		defaultMessage: 'Add {fieldName}',
		description:
			'An accessibility label for an edit button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button allows the user to edit the contents of the input field. Used when input content is Empty',
	},
	extendedEditButtonLabel: {
		id: 'inline-edit.extended-edit-button-label',
		defaultMessage: '{inputFieldValue}- edit {fieldName}',
		description:
			'An accessibility label for an edit button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Pressing the button allows the user to edit the contents of the input field.',
	},
	disabledEditButtonLabel: {
		id: 'inline-edit.disabled-edit-button-label',
		defaultMessage: '{fieldName} - can’t be edited',
		description:
			'An accessibility label for an edit button in an input field. The fieldName parameter refers to an optional heading for what the field is controlling. Explains that field cannot be changed',
	},
	disabledReporterTooltip: {
		id: 'inline-edit.disabled-inline-edit-tooltip',
		defaultMessage: '{fieldName} can’t be edited',
		description: 'Tooltip text. Appears on the disabled inline-edit, when hovering.',
	},
	columnTitleAriaLabel: {
		id: 'inline-edit.column-title-aria-label',
		description: 'Add column name input field aria label for textfield',
		defaultMessage: 'Add column name',
	},
});
